import React, { Component } from 'react';
import { Table, Icon, Divider, Row, Button, Modal, message, Input, Spin, Popconfirm } from 'antd';
import { Link } from "react-router-dom";
import moment from "moment";
import './index.scss';

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id || "",
            data: [],
            visible: false,
            loadingSave: false,
            loading: true,
            hotel: {
                name: "",
                email: "",
                password: "",
            },
            type: "",
            hotelData: {},
            info: sessionStorage.getItem('info') ? JSON.parse(sessionStorage.getItem('info')) : { data: {} },
            auth: ""
        }
    }

    componentDidMount() {
        this.getHotel();
        this.getData();
    }

    getHotel = () => {
        fetch('/getHotel?id=' + this.state.id, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                this.setState({
                    hotelData: { ...x.data[0] },
                });
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        })
    }

    getData = () => {
        fetch('/getUser?comid=' + this.state.id, { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            if (x.status == 1) {
                this.setState({
                    data: x.data || [],
                    auth: x.msg || ""
                });
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        })
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    handleOk = (e) => {
        this.setState({ loadingSave: true });
        let dataTotal = this.state.data;

        let data = { ...this.state.hotel };
        data.comid = this.state.id;
        data.created_at = moment().format('YYYY-MM-DD HH:mm:ss');
        if (!data.name || !data.email || !data.password) {
            message.error('员工信息不能为空');
            this.setState({ loadingSave: false });
            return
        }

        if (data.id) {
            let arr = dataTotal.filter(x => data.id);
            if (arr[0].password === data.password) {
                delete data.password
            };
        }

        delete data.add_time;
        let dataFrom = new FormData();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataFrom.append(key, data[key]);
            }
        }

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addUser', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('保存成功！');
                this.getData();
                this.setState({
                    visible: false,
                    loadingSave: false,
                    loading: true,
                    hotel: {
                        name: "",
                        email: "",
                        password: "",
                    }
                });
                return
            }
            message.error('保存失败！' + x.msg);
            this.setState({
                loadingSave: false
            });

        }).catch(err => {
            console.error(err);
            message.error('数据添加失败！')
            this.setState({
                loadingSave: false
            });
        })
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
            hotel: {
                name: "",
                email: "",
                password: "",
            }
        });
    } 

    confirm = (data) => {
        if (this.state.info.data.email != 'admin') {
            message.error('权限不足！')
            return
        }
        fetch('/deleteUser?id=' + data.id, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                this.getData();
                message.info('删除成功！');
                return
            }
            message.info('删除失败！');
        }).catch(err => {
            message.info('删除失败！');
            console.error(err);
        })
    }

    render() {
        const { data, auth } = this.state;
        let columns = [{
            title: '名称',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: '账号',
            dataIndex: 'email',
            key: 'email',
        }];
        if (auth == 'admin') {
            columns.push({
                title: '操作',
                key: 'add_time',
                render: (record) => {
                    return (
                        <div>
                            <span
                                style={{ color: "#1890ff", cursor: "pointer" }}
                                onClick={() => {
                                    let hotel = { ...record }
                                    this.setState({
                                        hotel,
                                        visible: true
                                    });
                                }}
                            >编辑</span>
                            <span>
                                <Icon type="minus" />
                                <Popconfirm
                                    title="确定要删除这个成员?"
                                    onConfirm={this.confirm.bind(this, record)}
                                    onCancel={() => { }}
                                    okText="是"
                                    cancelText="否"
                                >
                                    <span style={{ color: "#1890ff", cursor: "pointer" }} >删除</span>
                                </Popconfirm>
                            </span> 
                        </div>
                    )
                }
            })
        }
        return (
            <div className='settings'>
                <Row style={{ margin: '20px 0' }} type="flex" justify="space-between" textAlign="center">
                    <span style={{ fontSize: 20, color: "black" }}>
                        {this.state.hotelData.name || ""}
                    </span>
                    {auth == 'admin' && <Button
                        type="primary"
                        onClick={this.showModal}
                    >新增员工</Button>}
                </Row>
                <Spin spinning={this.state.loading}>
                    <Table
                        style={{ marginTop: 20 }}
                        columns={columns}
                        dataSource={data}
                        bordered
                        pagination={false}
                        rowKey={(item, index) => index}
                    />
                </Spin>

                <Row style={{ textAlign: "right", marginTop: 20 }}>
                    <Button
                        key="submit"
                        type="primary"
                        onClick={() => {
                            this.props.history.goBack();
                        }}
                    >
                        返回
                    </Button>
                </Row>
                <Modal
                    title={this.state.hotel.id ? '员工编辑' : "员工添加"}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Row className="modal">
                        <Row>
                            <span>员工名称：</span>
                            <Input
                                placeholder="请输入员工名称"
                                style={{ width: '60%', marginLeft: 10 }}
                                value={this.state.hotel.name}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.name = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content">
                            <span>登录账号：</span>
                            <Input
                                placeholder="请输入登录账号"
                                style={{ width: '60%', marginLeft: 10 }}
                                value={this.state.hotel.email}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.email = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content" >
                            <span>密码：</span>
                            <Input
                                placeholder="请输入密码"
                                style={{ width: '60%', marginLeft: 38, display: "none" }}
                                value={this.state.hotel.password}
                                type='password'
                                name="ppp"
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.password = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                            <Input
                                placeholder="请输入密码"
                                style={{ width: '60%', marginLeft: 38 }}
                                value={this.state.hotel.password}
                                type='password'
                                name="ppp"
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.password = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>

                    </Row>
                </Modal>
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/setting/hotel.js